const STORAGE_KEY = 'bts_payment_country';

const TZ_TO_COUNTRY: Record<string, string> = {
  'America/Santiago': 'CL',
  'Pacific/Easter': 'CL',
  'America/Bogota': 'CO',
  'America/Mexico_City': 'MX',
  'America/Cancun': 'MX',
  'America/Monterrey': 'MX',
  'America/Tijuana': 'MX',
  'America/Lima': 'PE',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Los_Angeles': 'US',
  'America/Argentina/Buenos_Aires': 'AR',
  'America/Sao_Paulo': 'BR',
};

export function detectBrowserCountry(fallback = 'CL'): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && /^[A-Z]{2}$/.test(stored)) return stored;
  } catch {
    // ignore
  }

  const lang = typeof navigator !== 'undefined' ? navigator.language || '' : '';
  const region = lang.replace('_', '-').split('-')[1];
  if (region && /^[A-Za-z]{2}$/.test(region)) {
    return region.toUpperCase();
  }

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TZ_TO_COUNTRY[tz]) return TZ_TO_COUNTRY[tz];
  } catch {
    // ignore
  }

  return fallback;
}

export function setBrowserCountry(code: string): void {
  const normalized = code.toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return;
  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // ignore
  }
}

const ZERO_DECIMAL = new Set(['CLP', 'COP', 'JPY', 'KRW']);

export function formatMoney(amount: number, currency = 'CLP', locale?: string): string {
  const code = (currency || 'CLP').toUpperCase();
  const zero = ZERO_DECIMAL.has(code);
  const value = zero ? amount : amount / 100;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      maximumFractionDigits: zero ? 0 : 2,
      minimumFractionDigits: zero ? 0 : 2,
    }).format(value);
  } catch {
    return `${code} ${value}`;
  }
}
